import { Box, Container, Link, Typography } from "@mui/material";
import React from "react";
import { Helmet } from "react-helmet";
import imgStory from "../images/story.webp";

const Contact = () => {
  return (
    <>
      <Helmet>
        <title>
          Contact us | MeridioAI
        </title>
        <meta
          name="description"
          content="MeridioAI"
        />
        <meta
          property="og:title"
          content="Contact us | MeridioAI"
        />
        <meta
          property="og:description"
          content="MeridioAI"
        />
      </Helmet>
      <Box>
        <Box sx={{ overflowX: "hidden", maxWidth: "100%" }}>
          <Container maxWidth="lg" sx={{ position: "relative" }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                flexDirection: { xs: "column", md: "row" },
                mt: { xs: 0, lg: 10 },
                mb: 5,
              }}
            >
              <Box
                sx={{
                  width: { xs: "100%", md: "50%" },
                  display: "flex",
                  flexDirection: "column",
                  alignItems: { xs: "center", md: "flex-start" },
                }}
              >
                <Typography variant="h3" component="h1">
                  Contact us
                </Typography>
                <Typography
                  variant="body"
                  component="p"
                  sx={{ py: 4 }}
                >
                  We'd love to hear from you. Reach out to us at{" "}
                  <Link href="mailto:contact@meridioai.com">
                    contact@meridioai.com
                  </Link>
                  {" "}and let us know how we can help take your business to the next level.
                </Typography>
              </Box>
              <Box
                sx={{
                  width: { xs: "100%", md: "45%" },
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mt: { xs: 4, md: 0 },
                }}
              >
                <Box
                  component="img"
                  src={imgStory}
                  alt="MeridioAI team"
                  sx={{
                    width: "100%",
                    maxWidth: 480,
                    borderRadius: "12px",
                  }}
                />
              </Box>
            </Box>
          </Container>
        </Box>
      </Box>
    </>
  );
};

export default Contact;
